@if (show) {
  <div class="dialog-box-container">
    <div class="dialog-box">
      <span class="message-header">{{ 'ATTENTION_TEXT' | translate }}</span>
      <p class="message-body">{{ message | translate: param }}</p>
      <div class="flex-center">
        <button class="btn btn-primary dialog-ok mr-3" (click)="ok()">{{ okText | translate }}</button>
        @if (!hideCancel) {
          <button class="btn link-btn dialog-cancel" (click)="cancel()">{{ cancelText | translate }}</button>
        }
      </div>
    </div>
  </div>
}
